










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class SearchTag extends Vue {
  @Prop()
  public label!: string;

  @Prop()
  public active!: boolean;
}
